import { apiService } from "./apiService";
import urlConfig from "../../config/domain";
import bStrg, { setbStrg } from "./storageHelper";

//convert slash contained datestring to valid date with hypen separated
export const dateTimeFormat = (date: string, split = "/") => {
	if (date) {
		let temp = split !== " " ? date.split(" ") : [date],
			splitSlash = temp[0].indexOf(split) >= 0 ? temp[0].split(split) : date;
		temp[0] = splitSlash[2] + "-" + splitSlash[1] + "-" + splitSlash[0];
		let newdate = temp[0];
		temp[1] ? (newdate = temp[0] + " " + temp[1]) : (newdate = temp[0]);
		return new Date(newdate);
	} else {
		return new Date();
	}
};

// converts DD/MM/YYYY to new Date(MM/DD/YYYY)
export const dateFormat = (date: string) => {
	const splitDate = date.split("/");
	return new Date(+splitDate[2], +splitDate[1] - 1, +splitDate[0]);
};

//api to fetch the server current Date time
export function GetCurrentDatetime(callback: CallableFunction) {
	apiService(
		{
			url: urlConfig.market.root + "GetCurrentDatetime",
			method: "GET"
		},
		callback
	);
}
//callback method which receives today's date and time
function TodayDateTime(res: any) {
	if (!res.error) {
		setbStrg("todayDate", JSON.parse(res).JsonData);
	}
}
//if server's today's date and time call an api and update the same,
//this storage is avialble until page reloads
if (!bStrg("todayDate")) {
	GetCurrentDatetime(TodayDateTime);
}

export function GetNoOfDaysOrMonths(from: string, to: string, type: string): number {
	const OneDay: number = 1000 * 60 * 60 * 24;
	let diffDaysOrMonths: number = 0;
	const frmDate: Date = new Date(from);
	const toDate: Date = new Date(to);
	switch (type) {
		case "monthly":
			let months: number = (frmDate.getFullYear() - toDate.getFullYear()) * 12;
			months -= toDate.getMonth();
			months = frmDate.getMonth() - toDate.getMonth();
			months = months <= 0 ? 0 : months;
			diffDaysOrMonths = months;
			break;
		case "daily":
			diffDaysOrMonths = (frmDate.getTime() - toDate.getTime()) / OneDay;
			break;
		case "weekly":
			diffDaysOrMonths = (frmDate.getTime() - toDate.getTime()) / (7 * OneDay);
			break;
		default:
			diffDaysOrMonths = 0;
			break;
	}

	return Math.round(diffDaysOrMonths);
}
//add number of days to the date sent in paramter
export const addDays = (date: Date, days: number): Date => {
	let TempDate = date;
	TempDate.setDate(TempDate.getDate() + days);

	return TempDate;
};
//minus number of days to the date sent in paramter

export const subDays = (date: Date, days: number): Date => {
	let TempDate = date;
	TempDate.setDate(TempDate.getDate() - days);

	return TempDate;
};
export default dateTimeFormat;
